module.exports = __webpack_public_path__ + "img/7.68246d54.png";